import { Alert, Button, Stack, Typography } from '@mui/material';
import { API_ENDPOINTS } from '../../../config/apiConfig';
import { explainDrift, summaryForDrift } from '../../../utilities/locatorDrift/locatorFormatters';
import SuggestionPanel from './SuggestionPanel';
import { driftDetailStyles } from './screenDriftStyles';

export default function DriftDetail({ item }) {
  const versionB = item.version_b || {};
  const suggestions = Array.isArray(versionB.suggestions || item.suggestions)
    ? versionB.suggestions || item.suggestions
    : [];
  const locatorBy = item.locator_by || item.by || '';
  const locatorValue = item.locator_value || item.value || '';
  const drift = (item.status || item.drift || '').toLowerCase();

  return (
    <Stack spacing={1.5}>
      <Typography variant="body2" fontWeight={800}>
        {summaryForDrift(item)}
      </Typography>
      <Alert severity={drift === 'regression' ? 'error' : drift === 'fixed' ? 'success' : 'info'}>
        {explainDrift({
          ...item,
          locator_by: locatorBy,
          locator_value: locatorValue,
          durationA: item.version_a?.duration_ms ?? item.duration_a,
          durationB: item.version_b?.duration_ms ?? item.duration_b,
        })}
      </Alert>
      {versionB.page_source_file && (
        <Button
          size="small"
          href={API_ENDPOINTS.PAGE_SOURCE_FILE(versionB.page_source_file)}
          target="_blank"
          rel="noopener noreferrer"
          sx={driftDetailStyles.pageSourceButton}
        >
          Open Page Source
        </Button>
      )}
      {drift === 'regression' && suggestions.length > 0 && (
        <SuggestionPanel suggestions={suggestions} />
      )}
    </Stack>
  );
}
